import React, {useEffect} from 'react';
import {Route, Routes} from 'react-router-dom';
import Navbar from 'components/navbar';
import Footer from 'components/footer/Footer';
import routes from 'routes';
import UseAccountStore from '../../stores/DataStore';
import Spinner from '../../components/spinner';

const getRoutes = (routes: RoutesType[]): any => {
  return routes.map((prop, key) => {
    if (prop.layout === '/admin') {
      return <Route path={`/${prop.path}`} element={prop.component} key={key} />;
    } else {
      return null;
    }
  });
};

export default function Admin(props: {[x: string]: any}) {

  const state = UseAccountStore();

  useEffect(() => {
    (async () => {
      await state.refresh();
    })();
  }, []);

  if (state.loading) {
    return <Spinner/>;
  }

  document.documentElement.dir = 'ltr';
  return (
    <div className="flex h-full w-full">
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        <main className={`h-full flex-none transition-all md:pr-2`}>
          <div className="h-full">
            <Navbar onOpenSidenav={() => false} account={state.account} />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>{getRoutes(routes)}</Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
